// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3pBuN","insightsList":"newBusinessInsightsMenu_insightsList__1934z","active":"newBusinessInsightsMenu_active__3piJh"};